/**
 * Created by jacky on 5/20/16.
 * @flow
 * @providesModule Signup
 */

import React, { Component } from "react";
import {findDOMNode} from "react-dom";

import "./signup.scss";
import type {
    QueryObjType, EventType,
    ProcessingStatusType, WorkspaceInfoType
} from "../../../lib/query";
import { query } from '../../../lib/query';
import _ from "../../../constants";
import { escHandler, readCookie } from '../../../lib/utils';
import { GA, MP } from '../../../lib/analytics';
declare var contentPool;
declare var contentId;
declare var mixpanel;

type SignupData = {
    firstName?: string;
    lastName?: string;
    email?: string;
}

type SignupPropsType = {
    projectName: string;
    onLoginClicked: (e: any) => void;
    contentPool: string;
    contentId: string;
    onEsc: () => void;
}


type SignupStateType = {
    processing?: ProcessingStatusType;
    counter: number;
    workspaces?: Array<WorkspaceInfoType>;
    q?: QueryObjType;
    sessionKey?: string;
    failReason?: string;
    data?: SignupData;
}

let timeoutHandler: ?number;
const initialState: SignupStateType = {
    processing: 'dataQuery',
    counter: 0,
    failReason: void 0
}

export default class Signup extends Component {
    props: SignupPropsType;
    state: SignupStateType = initialState;
    _escHandler: () => void;

    componentDidMount() {
        findDOMNode(this.refs['bndUserFirstName']).focus();
        this._escHandler = escHandler(
            this.props.onEsc,
            () => GA({category: 'Acquire', action: 'FillSignUp'})
        );
    }

    componentWillUnmount() {
        this._escHandler();
    }

    _workspaceSelected = (id: string) => {
        const { sessionKey = '', q } = this.state;
        q && q.send({
            command: 'CreateContent',
            data: {
                sessionKey: sessionKey,
                workspaceId: id,
                contentPool: this.props.contentPool,
                contentId: this.props.contentId
            }
        });
    }

    _processingMessaging = (r: EventType, q: QueryObjType) => {
        if (timeoutHandler) {
            clearInterval(timeoutHandler);
            timeoutHandler = null;
        }
        switch (r.status) {
            case 'SignUpFailed':
            case 'ContentCreationFailed':
                GA({category: 'Acquire', action: 'SignUpFail', value: r.status});
                this.setState({processing: r.status, failReason: (r: any).data});
                break;
            case 'SelectWorkspace':
                this.setState({processing: r.status, workspaces: r.workspaces, sessionKey: r.sessionKey, q: q});
                break;
            case 'SignedUp':
                GA({category: 'Acquire', action: 'SignupWithContent', value: `${contentPool}/${contentId}`});
                MP('ST Signup', `${contentPool}/${contentId}`);
                mixpanel.alias(r.userId);
            case 'CreatingContent':
            case 'ContentCreated':
            case 'SignUpInitiated':
            case 'GoToURL':
                this.setState({processing: r.status, counter: Math.floor(++this.state.counter)});
                if (r.status == 'GoToURL') {
                    q.close();
                    timeoutHandler && clearInterval(timeoutHandler);
                    setTimeout(() => {
                        window.location.assign((r: any).url);
                    }, 1000);
                } else if (!timeoutHandler) {
                    timeoutHandler = setInterval(this._processingTick, 250);
                }
                break;
        }
    }

    _processingTick = () => {
        this.setState({
            counter: this.state.counter + 0.01
        })
    }

    onFormSubmit (ev: any) {
        ev.preventDefault();
        this.setState(initialState);
        setTimeout(() => {
            query(this._processingMessaging)
                .then((p: QueryObjType) => {
                    const d: SignupData = {};
                    const r = p.send({
                        command: 'SignUp',
                        data: {
                            firstName: d.firstName = findDOMNode(this.refs['bndUserFirstName']).value,
                            lastName: d.lastName = findDOMNode(this.refs['bndUserLastName']).value,
                            email: d.email = findDOMNode(this.refs['bndUserEmail']).value,
                            password: findDOMNode(this.refs['bndUserPassword']).value,
                            product: '',
                            contentPool: this.props.contentPool,
                            contentId: this.props.contentId,
                            signupPage: location.origin + location.pathname,
                            visitorSessionId: readCookie('casual_session')
                        }
                    })
                    this.setState({data: d});
                    return r;
                })
                .catch(e => {
                    console.error(e);
                })
        }, 0)
    }

    render () {
        const { processing: p, failReason, data: stored = {} } = this.state;
        let failReasonMessage;
        switch(failReason) {
            case 'AlreadyCompleted':
                failReasonMessage = 'User with such e-mail address already exists.<br />You may use this e-mail to login or sign up with a new username.';
                break;
            case 'BadInput':
            case 'GeneralError':
                failReasonMessage = 'Something bad is happend on server side, try again later';
                break;
            case 'FAIL':
                switch(p) {
                    case 'ContentCreationFailed':
                        failReasonMessage = 'Error while creating content. Oops...'
                        break;
                }
        }

        let r;
        switch (true) {
            case p == 'dataQuery' || !!failReason:
                r = (
                    <div>
                        <h1>
                            <span>{this.props.projectName.trim()}</span>
                            <span className="clsSmaller">Get this project plan for FREE</span>
                        </h1>
                        <div className="clsPopupNote">
                            <p>This How to guide has a built-in interactive project plan that you can execute in Casual &ndash; online project management tool.</p>
                        </div>
                        <form onSubmit={e => this.onFormSubmit(e)}>
                            <input ref="bndUserFirstName" required={true} placeholder="First Name" defaultValue={stored.firstName} />
                            <input ref="bndUserLastName" required={true} placeholder="Last Name" defaultValue={stored.lastName} />
                            <input ref="bndUserEmail" required={true} type="email" placeholder="Email Address" defaultValue={stored.email} />
                            <input ref="bndUserPassword" required={true} type="password" placeholder="Password" />
                            {failReason
                                ? <div className="clsErrorMessage" dangerouslySetInnerHTML={{__html: failReasonMessage}} />
                                : null
                            }
                            <button type="submit">GET STARTED</button>
                            <div className="clsTerms">
                                By signing up, you agree to our <a href="https://casual.pm/terms">Terms of Service</a>.
                            </div>
                            <div className="clsLoginWrapper">
                                Already have a Casual account? <a href="#" onClick={ e => { this.props.onLoginClicked(e); e.preventDefault();} }>Sign in</a>
                            </div>
                        </form>
                    </div>
                )
                break;
            case p == 'GoToURL':
                r = (
                    <div>
                        <h1>Done!</h1>
                        <div className="clsPopupNote">
                            We have created a content for you.<br />
                            You'll see it in a moment...
                        </div>
                    </div>
                );
                break;
            case p == 'SelectWorkspace':
                const { workspaces: w = [] } = this.state;
                r = (
                    <div>
                        <h1>Select Workspace</h1>
                        <div className="clsPopupNote">
                            You have multiple workspaces. Select one where content will be created:
                            <ul className="clsWorkspaceSelector">
                                {w.map(v => (
                                    <li key={v.id} className={!v.active ? 'clsDisabled' : ''} onClick={() => v.active ? this._workspaceSelected(v.id) : false}>{v.name}{!v.active ? '(inactive)' : null}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )
                break;
            default:
                r = (
                    <div>
                        <h1>Processing signup...</h1>
                        <div className="clsProgressBar">
                            <div className="clsProgressBarBody" style={{width: (this.state: any).counter * 20 + '%'}} />
                        </div>
                    </div>
                )
                break;
        }
        return (
            <div className="clsPopup clsSignup">
                {r}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Dialogs/Signup/signup.jsx